import request from '@/utils/request'

const api_name = '/api/evaluation/stepRealTimeReview'

/**
 * 实时评审
 */
export default {

    //列表
    getReviewResultList(bidSectionCode) {
        return request.get(`${api_name}/list/?bidSectionCode=${bidSectionCode}`)
    },

    //专家列表
    getExpertList(bidSectionCode) {
      return request.get(`${api_name}/expertList/?bidSectionCode=${bidSectionCode}`)
    },

    //评审结果详情
    getReviewResultDetail(params) {
        return request.get(`${api_name}/resultDetail`, params)
    },
      //对照表格
    getComparisonTable(data) {
        return request.post(`${api_name}/map`, data)
    },
}
